import { Component, ElementRef, Input } from '@angular/core';
import { PdfService } from '../../service/pdf-service';

@Component({
	selector: 'app-pdf-export-button',
	standalone: false,
	templateUrl: './pdf-export-button.component.html',
	styleUrl: './pdf-export-button.component.scss'
})
export class PdfExportButtonComponent {
	@Input() name!: string;
	@Input() heading!: string;
	@Input() resource!: ElementRef;
	@Input() alignRight= true;
	busy = false;

	constructor(private pdfService: PdfService) {

	}
	async exportPdf() {
		this.busy = true;
		if (!this.resource?.nativeElement) {
			console.error('Element not found');
			return;
		}
		try {
			await this.pdfService.exportPdf(this.name, this.heading, this.resource);
		} finally {
			this.busy = false;
		}
	}
}
